<template>
  <Modal
    extra-class="dea-modal__delete-user dea-modal--no-footer"
    :visible="visible"
    @modal-close="$emit('modal-close')"
  >
    <template #title>Confermi di voler cancellare {{ user.firstname }} dal tuo Profilo Famiglia Deascuola?</template>
    <template #content>
      <div class="dea-modal-delete-user-description dea-heading--regular-l">
        Se prosegui con l'eliminazione, i libri associati a {{ user.firstname }} saranno cancellati con il suo Profilo e
        non potrai più recuperarli o riattivarli.
      </div>
      <div class="dea-modal__delete-user-buttons">
        <Buttons class="dea-button--large" @click="$emit('delete-user')">Si, elimina {{ user.firstname }}</Buttons>
        <Buttons class="dea-button--large dea-button--outline" @click="$emit('modal-close')">No, annulla</Buttons>
      </div>
    </template>
  </Modal>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import Modal from "@/components/patterns/Modal";

export default {
  name: "DeleteUserModal",
  components: { Buttons, Modal },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-modal {
  &__delete-user {
    &-buttons {
      @include media("<=m") {
        flex-direction: column;
      }

      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
}
</style>
